export const IecStandardType = {
  ClassA: 0,
  ClassB: 1,
  ClassC: 2,
};
